import EditDashboardPage from './edit-dashboard';

export default EditDashboardPage;
